export function stringToColor(v: string): string {
  let hash = 0
  for (let i = 0; i < v.length; i++) {
    hash = v.charCodeAt(i) + ((hash << 5) - hash)
  }
  let colour = '#'
  for (let i = 0; i < 3; i++) {
    const value = (hash >> (i * 8)) & 0xff
    colour += ('00' + value.toString(16)).substr(-2)
  }
  return colour
}

export function hex2rgbColor(hex: string): string {
  const [r, g, b] = (hex.match(/\w\w/g) || []).map((x) => parseInt(x, 16))
  return `${r},${g},${b}`
}

export function hex2rgb(hex: string): string {
  const [r, g, b] = (hex.match(/\w\w/g) || []).map((x) => parseInt(x, 16))
  return `rgb(${r},${g},${b})`
}

export function hex2rgba(hex: string, alpha = 1): string {
  const [r, g, b] = (hex.match(/\w\w/g) || []).map((x) => parseInt(x, 16))
  return `rgba(${r},${g},${b},${alpha})`
}

export function rgba2hex(color: string): string {
  const values = color
    .replace(/rgba?\(/, '')
    .replace(/\)/, '')
    .replace(/[\s+]/g, '')
    .split(',')

  const a = parseFloat(values[3] || '1')
  const r = Math.floor(a * parseInt(values[0]) + (1 - a) * 255)
  const g = Math.floor(a * parseInt(values[1]) + (1 - a) * 255)
  const b = Math.floor(a * parseInt(values[2]) + (1 - a) * 255)

  return '#' + ('0' + r.toString(16)).slice(-2) + ('0' + g.toString(16)).slice(-2) + ('0' + b.toString(16)).slice(-2)
}

export function hex2HexAlpha(hex: string, alpha = 1): string {
  const rgba = hex2rgba(hex, alpha)
  const hexAlpha = rgba2hex(rgba)

  return hexAlpha
}

export const darkenColor = (color: string, amount: number = 0.2): string => {
  // Remove any leading #
  const hex = color.replace('#', '')

  // Convert hex to RGB
  const r = parseInt(hex.substring(0, 2), 16)
  const g = parseInt(hex.substring(2, 4), 16)
  const b = parseInt(hex.substring(4, 6), 16)

  // Darken each component
  const darkerR = Math.round(r * (1 - amount))
  const darkerG = Math.round(g * (1 - amount))
  const darkerB = Math.round(b * (1 - amount))

  // Convert back to hex
  const darkerHex =
    '#' +
    darkerR.toString(16).padStart(2, '0') +
    darkerG.toString(16).padStart(2, '0') +
    darkerB.toString(16).padStart(2, '0')

  return darkerHex
}
